import { t } from "ttag";
import { z } from "zod";

import { productSchema } from "@/features/products/models";

export const subscriptionSchema = z.object({
  productPriceId: productSchema.shape.prices.element.shape.id,

  hasConsent: z.literal<boolean>(true, {
    error: () => t`To continue, please check the "I agree" box`,
  }),
});

export type SubscriptionFormValues = z.infer<typeof subscriptionSchema>;
